module.exports = __webpack_public_path__ + "static/media/captions.cac28137.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/appletv-icons/captions.svg
// module id = 633
// module chunks = 0